var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 13,
    viewBox: "0 0 79 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 6.75C0.761719 3.43629 3.44801 0.75 6.76172 0.75C10.0754 0.75 12.7617 3.43629 12.7617 6.75C12.7617 10.0637 10.0754 12.75 6.76172 12.75C3.44801 12.75 0.761719 10.0637 0.761719 6.75Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.936 6.75C45.936 3.71243 48.3985 1.25 51.436 1.25C54.4736 1.25 56.936 3.71243 56.936 6.75C56.936 9.78757 54.4736 12.25 51.436 12.25C48.3985 12.25 45.936 9.78757 45.936 6.75Z",
    fill: "white",
    stroke: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76172 6.75C4.76172 5.64543 5.65715 4.75 6.76172 4.75C7.86629 4.75 8.76172 5.64543 8.76172 6.75C8.76172 7.85457 7.86629 8.75 6.76172 8.75C5.65715 8.75 4.76172 7.85457 4.76172 6.75Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3,
    width: 16,
    height: 8,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 3,
    width: 16,
    height: 8,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio2A);
export default __webpack_public_path__ + "static/media/Radio-2A.7beb43174c2045f9fb5d2583b1bc7537.svg";
export { ForwardRef as ReactComponent };